import { useEffect, useState, type FunctionComponent, } from "react";
import { TwitterShareButton, } from "react-share";
import { usePointsStore, } from "@stores/points";
import { Input, } from "@bracket/react-input";
import { useMessengerStore, } from "@bracket/react-messenger";
import "./Referrals.scss";




export declare type ReferFriendProps = {

};


export const ReferFriend: FunctionComponent<ReferFriendProps> = ({

}) => {

	const classes = () => [ "refer-friend" ].join(" ");
	const { sendMessage, } = useMessengerStore();
	const {
		// initializeForUser,
		initializedForUser,
		initializingForUser,
		users_referral_id,
		safary_referral_id,
	} = usePointsStore();

	// useEffect(() => {
	// 	if( !initializedForUser && !initializingForUser ) {
	// 		( async () => {
	// 			await initializeForUser();
	// 		})();
	// 	}
	// }, [ initializedForUser, initializingForUser, ]);

	const url = `https://x.bracket.fi/${safary_referral_id}/`;

	const onClick = () => {
		navigator.clipboard.writeText(url);
		sendMessage({ title: "Referral", severity: "success", message: "Your referral link can now be pasted from the clipboard." });
	}

	const urlLabel = () => {
		return safary_referral_id
		? `https://x.bracket.fi/${safary_referral_id}/`
		:	`loading your referral link`
	};

	const tweetContent = [
		`Do you know about @bracket_fi fam? 👀`,
		``,
		`Backed by @BinanceLabs and launching a platform for Liquid Staked DeFi led by OGs 👑`,
		``,
		`Join the community, jump in the quests, and here is my link to STAKE NOW  to stack [BARS] 🤝`,
		``,
		`[LFG]`,
		`#bracket`,
		``,
	].join("\n");

	return (
		<div className={classes()}>
			<div className="detail">
				<h5 className="text-white"><span className="highlight">Refer your friends</span> and earn a 20% referral boost.</h5>
			</div>
			<div className="refer">
				<p className="text-xxl font-med text-centered text-white">Your referral link</p>
				<Input value={urlLabel()} icon="Copy" iconPosition="end" disabled iconProps={{ onClick: onClick, }} />
				<TwitterShareButton
					url={urlLabel()}
					title={tweetContent}
					>
						<div className="fake-button">Share on X</div>
				</TwitterShareButton>
				
			</div>
		</div>
	);

}
